import moment from 'moment'

const mapExtraData = (rangeOfQuery, currentMonth) => {
  const diff = rangeOfQuery.end - rangeOfQuery.start + 1

  return new Array(diff).fill(1).map((n, item) => {
    const day = item + rangeOfQuery.start
    const formatDay = day < 10 ? `0${day}` : day

    const month = currentMonth
      ? Number(currentMonth.value) + 1
      : new Date().getMonth() + 1
    const formatMonth = month < 10 ? `0${month}` : month

    return {
      calls: 0,
      month: `${formatDay}`,
      date: `${moment().format('YYYY')}-${formatMonth}-${formatDay}`
    }
  })
}

export const mapStatsToData = (stats, range, month) => {
  if (!Array.isArray(stats) || stats.length === 0) {
    return stats
  }

  const lastDate = stats[stats.length - 1].created_at

  const daysInMonth = moment(lastDate).daysInMonth()

  const rangeMap = [
    { label: '01', start: 1, end: 15 },
    { label: '15', start: 15, end: daysInMonth },
    { label: 'all', start: 1, end: daysInMonth }
  ]

  const rangeOfQuery = range
    ? rangeMap.find(item => item.label === range)
    : rangeMap[2]

  let baseData = []

  if (rangeOfQuery) {
    baseData = mapExtraData(rangeOfQuery, month)
  }

  const finalData = baseData.map(item => {
    let data
    const stat = stats.find(stats => item.date === stats.created_at)

    if (stat) {
      data = {
        calls: stat.total_records,
        month: moment(stat.created_at).format('D')
      }
    }
    return data || item
  })

  return finalData
}

export const monthToDateFromAndTo = month => {
  const newMonth = moment().month(month)
  const daysInMonth = newMonth.daysInMonth()

  const from = newMonth.date(1).format('YYYY-MM-DD')
  const to = newMonth.date(daysInMonth).format('YYYY-MM-DD')

  return { to, from }
}
